import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Page/Shared/Footer';
import Navbar from '../Page/Shared/Header';

const Layout = () => {
    return (
        <div>
           <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="min-h-screen">
                <Outlet/>
            </div>
            <div className="-mb-12">
                <Footer/>
          </div>
        </div>
    );
};

export default Layout;